var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-items-center align-content-center justify-content-center mb-3"},[_c('div',{staticClass:"text-center number-circle"},[_vm._v(" "+_vm._s(_vm.numberValue)+" ")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }